import queryString from 'query-string'
import { mapKeys, camelCase } from 'lodash'
import apiConfig from '../../config/apiConfig'
import { normalizeDownloadFilename } from '../../helpers/bulkDownloadHelper'
import { convertUTCtoLocal } from '../utils/utils'
import {
  CHANNEL_NAME_MAPPING as DEFAULT_CHANNEL_NAME_MAPPING,
  EXCLUDED_CHANNELS as DEFAULT_EXCLUDED_CHANNELS,
  FILTER_CHANNEL_KEY,
  FILTER_CLASS_KEY,
  FILTER_DEPARTMENT_KEY,
  FILTER_SUBCLASS_KEY,
  FILTER_BRAND_KEY,
  FILTER_UPLOAD_DATE_KEY,
  FILTER_COLOR_HSV_KEY,
  FILTER_IS_ARCHIVED_KEY,
  FILTER_ASSET_TYPE_KEY,
} from '../constants/search'
import { SEARCH_TERM_FILTER_MAP } from '../../constants/search'
import { isEmptyObject } from '../../helpers/UtilityHelper'

export const assetsPayloadFromSearch = (assets = []) =>
  assets?.map((asset = {}) => assetToDetailedAsset(asset))
export const assetToDetailedAsset = (asset = {}) => {
  const { asset_details = {} } = asset
  const assetDetails = recursiveToCamel(asset_details)
  const assetCardDetails = {}
  const {
    renderUrls = {},
    assetId = '',
    originalAssetId = '',
    isDerivative = '',
    isReusable = '',
    masterChannel = '',
    isGenAiReady = false,
    moderationReviewStatus = null,
    moderationReviewedBy = '',
    moderationReviewComment = '',
    metadata: {
      fileMetadata = {},
      usageInfo = [],
      creativeUsageInstructions = {},
      projectInfo = {},
      itemInfo = [],
      assetClassification = {},
      ai = {},
    } = {},
    uploadedDate = null,
  } = assetDetails
  const {
    fileName = '',
    fileSizeMb = Number(0),
    fileType = '',
  } = fileMetadata || {}
  const userInfobyExpDate = sortUsageInfoByExpDate(usageInfo)
  const usageInfoLatest = usageInfoFormatted(userInfobyExpDate)
  assetCardDetails['render_urls'] = getDetailedRenderUrls(
    renderUrls,
    fileName,
    fileType,
  )
  assetCardDetails['renderUrls'] = getDetailedRenderUrls(
    renderUrls,
    fileName,
    fileType,
  )
  assetCardDetails['uploadedDate'] = convertUTCtoLocal(uploadedDate)
  assetCardDetails['originalUploadedDate'] = uploadedDate
  assetCardDetails['ai'] = ai
  assetCardDetails['usageInfo'] = usageInfoLatest
  assetCardDetails['itemInfo'] = itemInfo ?? []
  assetCardDetails['creativeUsageInstructions'] =
    creativeUsageInstructions ?? {}
  assetCardDetails['projectInfo'] = projectInfo ?? {}
  assetCardDetails['assetClassification'] = assetClassification ?? {}
  assetCardDetails['fileName'] = fileName
  assetCardDetails['fileSizeMb'] = fileSizeMb
  assetCardDetails['fileType'] = fileType
  assetCardDetails['assetId'] = assetId
  assetCardDetails['isDerivative'] = isDerivative
  assetCardDetails['isReusable'] = isReusable
  assetCardDetails['masterChannel'] = masterChannel
  assetCardDetails['originalAssetId'] = originalAssetId
  assetCardDetails['isGenAiReady'] = isGenAiReady
  assetCardDetails['moderationReviewStatus'] = moderationReviewStatus
  assetCardDetails['moderationReviewedBy'] = moderationReviewedBy
  assetCardDetails['moderationReviewComment'] = moderationReviewComment
  return assetCardDetails
}

export const usageInfoFormatted = (usageInfo = []) =>
  usageInfo?.map((obj) => {
    const { expirationDate } = obj
    const newObj = {
      expirationDateFormatted: convertUTCtoLocal(expirationDate, 'YYYY-MM-DD'),
    }
    return Object.assign({}, obj, newObj)
  })

export const getDetailedRenderUrls = (
  renderUrls = {},
  fileName = '',
  fileType = '',
) => {
  const {
    originalAssetUrl = '',
    previewAssetUrl = '',
    thumbnailAssetUrl = '',
    optimizedAssetUrl = '',
  } = renderUrls
  const previewFilename = fileName?.includes('.')
    ? fileName?.split('.')[0] + '.jpeg'
    : `${fileName}.jpeg`
  const newOptimizedAssetUrl = modifyScene7UrlForPreview(optimizedAssetUrl)
  const previewFromThumbnailUrl = getThumbnailToPreviewUrl(thumbnailAssetUrl)
  renderUrls['thumbnailSquareUrl'] = appendQueryParams(thumbnailAssetUrl, {
    make_square: true,
  })
  renderUrls['previewSquareUrl'] = appendQueryParams(previewAssetUrl, {
    make_square: true,
  })
  renderUrls['videoUrl'] = appendQueryParams(originalAssetUrl)
  renderUrls['downloadUrl'] =
    appendQueryParams(originalAssetUrl, {
      file_name: normalizeDownloadFilename(fileName, fileType),
      is_download: true,
    }) ?? originalAssetUrl
  renderUrls['downloadPreviewUrl'] =
    appendQueryParams(newOptimizedAssetUrl, {
      file_name: previewFilename,
      is_download: true,
    }) ?? newOptimizedAssetUrl
  renderUrls['previewThumbnail'] = appendQueryParams(previewFromThumbnailUrl, {
    make_square: true,
  })
  renderUrls['previewHoverThumbnail'] = appendQueryParams(optimizedAssetUrl, {
    make_square: true,
  })
  return renderUrls
}

export const getThumbnailToPreviewUrl = (imgSrc) => {
  let previewUrl = imgSrc
  if (previewUrl?.includes('THUMBNAIL')) {
    if (previewUrl?.includes('vault_digital_assets')) {
      previewUrl = imgSrc?.replace('THUMBNAIL', 'PREVIEW&hei=500&wid=500')
    } else {
      previewUrl = imgSrc?.replace('THUMBNAIL', 'PREVIEW&height=500&width=500')
    }
  } else if (previewUrl?.includes('is/content')) {
    previewUrl = imgSrc?.replace('is/content', 'is/image')
  }
  return previewUrl
}

export const modifyScene7UrlForPreview = (url = '') => {
  if (url?.includes('is/content')) {
    return url.replace('is/content', 'is/image')
  } else {
    return url
  }
}

export const appendQueryParams = (url = '', params = {}) => {
  if (url === null) {
    return ''
  }
  const { key = '' } = apiConfig
  const paramsObj = Object.assign({}, params, { key: key })
  const delimiter = url.indexOf('?') === -1 ? '?' : '&'
  return `${url}${delimiter}${queryString.stringify(paramsObj)}`
}
//utils
export const recursiveToCamel = (item) => {
  if (Array.isArray(item)) {
    return item.map((el) => recursiveToCamel(el))
  } else if (typeof item === 'function' || item !== Object(item)) {
    return item
  }
  return Object.fromEntries(
    Object.entries(item).map(([key, value]) => [
      key.replace(/([-_][a-z])/gi, (c) => c.toUpperCase().replace(/[-_]/g, '')),
      recursiveToCamel(value),
    ]),
  )
}
export const snakeCaseToCamelCase = (data = {}) =>
  mapKeys(data, (value, key) => camelCase(key))

export const sortUsageInfoByExpDate = (usage_info) => {
  const usageInfo = usage_info ? [...usage_info] : []
  usageInfo.sort(
    (item1, item2) =>
      new Date(item1.expirationDate) - new Date(item2.expirationDate),
  )
  return usageInfo
}

export const convertResponseToAutoCompleteOptions = (
  autoCompleteSuggestions = {},
  facetName = '',
) => {
  switch (facetName) {
    case 'ALL': {
      let ACOptions = []
      autoCompleteSuggestions['Brand']?.map((brandName = '') => {
        ACOptions.push({
          id: brandName,
          value: brandName,
          label: brandName,
          group: 'Brand',
        })
      })
      autoCompleteSuggestions['Department']?.map((brandName = '') => {
        ACOptions.push({
          id: brandName,
          value: brandName,
          label: brandName,
          group: 'Department',
        })
      })
      autoCompleteSuggestions['Channel']?.map((brandName = '') => {
        ACOptions.push({
          id: brandName,
          value: brandName,
          label: brandName,
          group: 'Channel',
        })
      })
      autoCompleteSuggestions['Sub Class']?.map((brandName = '') => {
        ACOptions.push({
          id: brandName,
          value: brandName,
          label: brandName,
          group: 'Sub Class',
        })
      })
      return ACOptions
    }
  }
}

export const transformFilterNameToKey = (filterName = '') => {
  switch (filterName) {
    case 'Brand':
      return FILTER_BRAND_KEY
    case 'Department':
      return FILTER_DEPARTMENT_KEY
    case 'Class':
      return FILTER_CLASS_KEY
    case 'Sub Class':
      return FILTER_SUBCLASS_KEY
    case 'Channel':
      return FILTER_CHANNEL_KEY
    default:
      return ''
  }
}

export const getFiltersPayload = (filtersList = []) => {
  let newFilters = {}
  filtersList.forEach((filter) => {
    const { group = '', value = '' } = filter
    const filterKey = transformFilterNameToKey(group)
    if (newFilters[filterKey]) {
      newFilters[filterKey].push(value)
    } else {
      newFilters[filterKey] = [value]
    }
  })
  return newFilters
}

export const ignoreFilterKeyList = [
  'isConfidential',
  'isLatestRevision',
  'creativeAssetStatus',
  'status',
  'uploadedDate',
  'isArchived',
  FILTER_COLOR_HSV_KEY,
  ...Object.keys(SEARCH_TERM_FILTER_MAP || {}),
]

export const getClassificationCode = (selectedValue, facetDetails) => {
  if (isEmptyObject(facetDetails)) {
    return ''
  }
  const filteredClassification =
    facetDetails?.['records'].find(
      (facetRecords) => facetRecords.id === selectedValue,
    ) || {}
  const { category = '', value = '' } = filteredClassification
  return `${category}_${value}`
}

export const getClassificationLabels = (
  selectedValues = [],
  classificationData = [],
) => {
  const filteredData = classificationData.filter((classification) =>
    selectedValues.includes(classification.id),
  )
  let mappedData = filteredData.map((classification) => {
    const { category = '', value = '' } = classification
    return `${category}_${value}`
  })
  return mappedData
}

const getAppliedFiltersLabel = (
  key = '',
  value = '',
  facets = {},
  classificationFacets = {},
) => {
  switch (key) {
    case FILTER_ASSET_TYPE_KEY: {
      const relevantFacets =
        (facets?.facetResponse || []).find((f) => f.path === key) ||
        classificationFacets
      return getClassificationCode(value, relevantFacets)
    }
    default:
      return value
  }
}

export const convertFiltersAndTextSearchToConfig = (
  filters = {},
  facets = {},
  channelConfig = {},
  classificationFacets = {},
) => {
  const {
    CHANNEL_NAME_MAPPING = DEFAULT_CHANNEL_NAME_MAPPING,
    EXCLUDED_CHANNELS = DEFAULT_EXCLUDED_CHANNELS,
  } = channelConfig
  let newFiltersConfig = []
  Object.keys(filters).length &&
    Object.keys(filters).map((key) => {
      if (!ignoreFilterKeyList.includes(key)) {
        const filterValue = filters[key]

        // Special handling for channel filters - aggregate variants to canonical names
        if (key === FILTER_CHANNEL_KEY && filterValue.length) {
          const canonicalChannelsSet = new Set()

          filterValue.forEach((value) => {
            // Skip excluded channels
            if (EXCLUDED_CHANNELS.includes(value)) {
              return
            }

            // Map to canonical name or use original
            const canonicalName = CHANNEL_NAME_MAPPING[value] || value
            canonicalChannelsSet.add(canonicalName)
          })

          // Add each unique canonical channel to the config
          canonicalChannelsSet.forEach((canonicalName) => {
            newFiltersConfig.push({
              id: canonicalName,
              value: canonicalName,
              label: getAppliedFiltersLabel(key, canonicalName, facets),
              group: key,
            })
          })
        } else if (filterValue.length) {
          filterValue.forEach((value) => {
            newFiltersConfig.push({
              id: value,
              value: value,
              label: getAppliedFiltersLabel(
                key,
                value,
                facets,
                classificationFacets,
              ),
              group: key,
            })
          })
        }
      } else if (key === 'uploadedDate') {
        const filterValue = filters[key]
        if (filterValue.length) {
          const uploadDateFilter = filterValue.join(' to ')
          newFiltersConfig.push({
            id: uploadDateFilter,
            value: uploadDateFilter,
            label: uploadDateFilter,
            group: FILTER_UPLOAD_DATE_KEY,
          })
        }
      } else if (key === FILTER_IS_ARCHIVED_KEY) {
        const filterValue = filters[key]
        if (filterValue.length && filterValue[0] === 'true') {
          newFiltersConfig.push({
            id: filterValue[0],
            value: filterValue[0],
            label: 'Show Only Archived',
            group: FILTER_IS_ARCHIVED_KEY,
          })
        } else if (filterValue.length === Number(0)) {
          //When we get filterValue as empty array from BE, it means include archived assets filter is selected
          newFiltersConfig.push({
            id: 'ALL',
            value: 'ALL',
            label: 'Include Archived',
            group: FILTER_IS_ARCHIVED_KEY,
          })
        }
      }
    })
  return newFiltersConfig
}

export const removeFilterValueFromExistingFilters = (
  existingFilters = {},
  filterToRemove = {},
  channelConfig = {},
) => {
  const {
    CHANNEL_NAME_MAPPING = DEFAULT_CHANNEL_NAME_MAPPING,
    EXCLUDED_CHANNELS = DEFAULT_EXCLUDED_CHANNELS,
  } = channelConfig
  const filterGroup = filterToRemove.group
  const filterValue = filterToRemove.value

  if (filterGroup in existingFilters) {
    let existingFilterValue = existingFilters[filterGroup]

    // Special handling for channel filters - remove all variants of the canonical name
    if (filterGroup === FILTER_CHANNEL_KEY) {
      const variantsToRemove = new Set()

      // Add the canonical name itself
      variantsToRemove.add(filterValue)

      // Find all variants that map to this canonical name
      Object.entries(CHANNEL_NAME_MAPPING).forEach(
        ([variantName, mappedName]) => {
          if (mappedName === filterValue) {
            variantsToRemove.add(variantName)
          }
        },
      )

      // Remove all variants from the filter
      existingFilterValue = existingFilterValue.filter(
        (item) => !variantsToRemove.has(item),
      )
    } else {
      existingFilterValue = existingFilterValue.filter(
        (item) => item != filterValue,
      )
    }

    if (existingFilterValue.length) {
      if (filterGroup === FILTER_UPLOAD_DATE_KEY) {
        delete existingFilters[filterGroup]
      } else {
        existingFilters[filterGroup] = existingFilterValue
      }
    } else {
      if (filterGroup === FILTER_IS_ARCHIVED_KEY) {
        existingFilters[filterGroup] = ['false']
      } else {
        delete existingFilters[filterGroup]
      }
      if (filterGroup === FILTER_DEPARTMENT_KEY) {
        delete existingFilters[FILTER_CLASS_KEY]
      }
    }
  }

  return existingFilters
}

export const mapFacetDataToCheckboxConfig = (fileTypeList = []) => {
  const result = Object.groupBy(fileTypeList, ({ category }) => category)
  return result
}

export const getUniqueFiltersAndCount = (
  defaultFilter = {},
  currentFilter = {},
) => {
  const result = {}

  Object.entries(currentFilter).forEach(([key, values]) => {
    const defaultValues = defaultFilter[key] || []
    // Filter out keys that don't exist in default or values that differ
    const filteredValues = values.filter((v) => !defaultValues.includes(v))
    if (filteredValues.length > 0) {
      result[key] = filteredValues
    }
  })

  // Count total values across all keys
  const totalValuesCount = Object.values(result).reduce(
    (acc, arr) => acc + arr.length,
    0,
  )

  return { uniqueFilters: result, totalValuesCount }
}

/**
 * Returns the key names from an object whose values match the provided value.
 * @param {Object} obj - The object to search.
 * @param {*} value - The value to match.
 * @returns {string[]} - Array of key names whose values match.
 */
export function getKeyByValue(obj, value) {
  return Object.keys(obj).find((key) => {
    if (
      typeof obj[key] === 'object' &&
      obj[key] !== null &&
      typeof value === 'object' &&
      value !== null
    ) {
      return JSON.stringify(obj[key]) === JSON.stringify(value)
    }
    return obj[key] === value
  })
}
